import parser from "html-react-parser";
import React, { Component } from "react";
import IconDownload from "canvas-core-react/lib/IconDownload";
import { ReactTitle } from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

/*Imports de iconos del diseño */
import billImage from "../../../../static/images/billIcon.svg";

import MainTemplate from "../mainTemplate";
import FileUpload from "../../utils/fileUpdload";

export class FileBill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      successFiles: 0,
      failedFailes: 0,
    };
  }

  render() {
    const { t } = this.props;
    return (
      <MainTemplate>
        <ReactTitle
          title={`${t("invoices.file.meta.title")} - ${t("appName")}`}
        />
        <div className="col-12 addBill">
          <div className="header-providers">
            <div className="title">
              <img src={billImage} />
              <p className="p-list">{t("invoices.file.title")}</p>
            </div>
            <div className="actions flex-element left-flex report-download">
              <p>{t(`general.labels.downloadExample`)}</p>
              <a href={`/static/documents/plantilla_facturas.csv`}>
                Formato unificado <IconDownload />
              </a>
            </div>
          </div>
          <div className="main-addProvider">
            <FileUpload
              successMessage={t("invoices.file.sucessMsg")}
              errorMessage={t("invoices.file.errMsg")}
              postUrl={`/bills/massive`}
              redirect={() => this.props.history.push(`/bills`)}
            />
          </div>
          <div className="requirement">
            <h2>{t("invoices.file.requirements")}</h2>
            <ol>
              <li>{parser(t("invoices.file.requirements1"))}</li>
              <li>{parser(t("invoices.file.requirements2"))}</li>
              <li>{parser(t("invoices.file.requirements3"))}</li>
              <li>{parser(t("invoices.file.requirements4"))}</li>
            </ol>
          </div>
        </div>
      </MainTemplate>
    );
  }
}

export default withRouter(withTranslation()(FileBill));
